import { useT } from "@/lib/i18n";

export default function LangToggle({ className = "" }) {
  const { lang, setLang } = useT();
  return (
    <div className={`inline-flex rounded-lg bg-slate-800/70 p-0.5 ${className}`} data-testid="dv-lang-toggle" role="group" aria-label="Language">
      {["el", "en"].map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => setLang(l)}
          data-testid={`dv-lang-${l}`}
          aria-pressed={lang === l}
          className={`dv-btn h-8 px-2.5 rounded-md text-xs font-bold uppercase tracking-wide ${
            lang === l ? "bg-white text-slate-900" : "text-slate-300 hover:text-white"
          }`}
        >
          {l === "el" ? "ΕΛ" : "EN"}
        </button>
      ))}
    </div>
  );
}
